export class TestLock {
  lockID: string;
  lockTypeID: number;
  lockTypeName: string;
  countryID: number;
  countryName: string;
  serialNumber: string;
  lockOrAsset: string;
  comment: string;
  disabled: boolean;
  logUser: string;
  editMode: boolean;
}
